module.exports = __webpack_public_path__ + "img/LogoDashboard-16.5ef48dea.svg";